<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">  
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  
  <div class=" col-md-6 col-12 p-0">	
    
      <div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
        <h3><strong>{{msglist[$route.params.language][1]}}</strong></h3>
        <div class="ml-auto"><router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
          <button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][0]}}</button><!--KH 設定-->
          </router-link></div>
      </div>
    
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
		  				<div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][2]}}</div> <!--KH目標值 :-->
				  			
				  			<div class="col-12 px-0 row mx-0 align-self-center" style="width:180px">
                     <input style="font-size:1.2rem; font-weight: bold" maxlength="4" class="col form-control text-center" size="3" v-model=targetKH name="TargetTankKH" type="text" value="7.5">
                     <span class="col-auto px-2 align-self-center">dKH</span>
                </div>
                <div class="col-12 px-0 py-2">{{msglist[$route.params.language][3]}}</div> <!--小於目標，會開啟KH滴定-->
		  				</div>
		  		</div>
		</div>
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  	<div class="col-12 px-0 row mx-0">
		  			<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
              <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][4]}} {{msglist[$route.params.language][6]}}</div>  <!--超出目標+- -->
				  				<div class="px-2 row align-self-center" style="width:180px">
                      <span class="col-auto px-2 align-self-center" style="font-size:1.2rem; font-weight: bold">+-</span>
                    <input style="font-size:1.2rem; font-weight: bold" maxlength="3" class="col form-control text-center" size="2" v-model=KHspec name="KH_specification" type="text" value="0.5">
                      <span class="col-auto px-2 align-self-center">dKH</span>
                  </div>
		  				    <!--<div class="col-12 px-0 py-2">{{msglist[$route.params.language][6]}}</div> 發送E-mail通知-->
                </div>
		  		</div>
		  </div>
      <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEBklEQVR4nO2ZzWuVRxTGf2JMIurCRBShK5tCMTVJU1NQ1CpIoSsXSv4DCXbjptta40baqteNxez8gIpCEj8Q/wipiqZ+gQtxpUalFluT6I0ceAYOd9E7c995b5LiAy/c+87MmfeZ8zFnzsBH/D/wCXAMGGKBYhlwGJgCZoEHLEDsAB6LwHvgd6DHtbepzzAwDtwFXgLTIm6//1Sb9dmuMU3DIuAn4J1IXAcGXHs/MAK8UnvKY2NOAl+WTWIJcNZpwVZysdr6gGs1H3YDOALskbZWSsYS/e5R21HgphtXBa7WaDgricua6DXwrd4vBSpOQ9b2C/B5A3PYmF8lw2TNiGR7TnMKmngGfKX3nwG39H5aq28rXRQdioIzkm3a6soglwNutQOJr4Hnem+O3Et+9AH33AJ6X0zGDpnNe2dORuJvTTCuMByL4AexWA5cdAvZEJllLsSaYwdzCpo45Zy9LCKGFuC008ynJOKwC7GL5di3nCZSSTRKJJC55KJhe0raMSWTCuqsOJ9IMaccRIKZ3dd4CyxROKYB55zjzegp4thFiKDNMnzHBiIwpNwpbErXUleiJCLeMq6QiH4N/CvDPpGDSIciWFWWEo0RTW67LvOACLIMk/MbkWhzCWAjaUdZRNZLzgugNXZDDCGPeUTEcFuythGB4UxOXgaRimTZsaIuQnpg6fZ8IzIoWWMxne+qc1TMbjKRXsmaiOk8qc4W8opipyNiv4tilWRZ7lcXobAQFRnq4JEjYr+Lok2y3jabyBNHxA5iq5tJZFKdOymO70RmWjLvFCSzKsW0cjs7+viJDGR6U5x9PHP4zUlmUONH52JDzEmmorFWU6iL7a6SUQZWi0QjZO5o3NbYyPAyY9JYj8z3kWO61X9SNbconMyYxv8XmX0J/Y+mpvHheFnVYSbHDl8UnSpHVd2x24qIUbiqFbCz/FzjuL7FSrhhoR8Ce2MG97hDf9LxMjP69Q22qX6hd2Opph/s8p5KM83GChVEZlUoN3wjE3sDrIkV1O7K/xdVNGsWWtxtwB+Kpq1uH/oxVWCXypazKmM2g0wLcEZzPgXW1dTeHjR62zXg7jAulWxmK2ruZTbq/W6Z1JSK6g1jwGnmfknXZf3OJ546EluAf/R+f46JulRdCbdLlUzpfqdC7IzziWBOm12mkbQZxgSAI27S1/pvdadUdCsyhruXaUWnYP+7FJ2s7XyDtwF1sUG12Ko7Bd6Wlga193Qo0rRq1fvUVnG5VrgMNb8wYsHZf3ayR8oi4dEnlb+oueGNeSwBPFFT7d/k7mRM6z/QZLQqvT6og8+EPnRKz6S0MKoC25aaLNbIXHBaeCT/WHAI0epf4JBuyxYk7H7GHH/tXH/IR5ABHwDCcXhp13IQVgAAAABJRU5ErkJggg=="></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][7]}}</div> <!--每-->
				  				<div class="px-0 row mx-0 align-self-center" style="width:180px">
				  					<select style="font-size:1.2rem; font-weight: bold" v-model=timeHr name="Timer_value" class="col form-control">
				  						<option value="1" selected="selected">1 {{msglist[$route.params.language][14]}}</option>
				  						<option value="2">2  </option>
				  						<option value="3">3  </option>
				  						<option value="4">4  </option>
				  						<option value="6">6  </option>
				  					</select>
                    <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][8]}}</span>
				  				</div>
                  <div class="col-12 px-0 py-2">{{msglist[$route.params.language][9]}}</div> <!--每小時測一次，控制更精確-->
		  				</div>
		  		</div>
		  </div>
      <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);"> <!--休眠時間--> 
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEnUlEQVR4nO2aTWgdVRTHf9q0SbVd1JSH4EZRsba2SQPqQtEU3dSNippN3LoQFBGRLkS0C1Fr4tONtjvrRlo/Gr/oQlduBOtHNbEf2gpWrEX7galVm6d9cuA/cJjMvJk7704SoX8YmHc/zj3/ueece+69D87j/4UlwAiwEzgInAVmgMPADuB+YGmEcUzGqGQeAlrAX8AB4A3gPulSCfcAPwDtgudN4IIuSFjft0uMcwi4O0TwhcALTsDXwMPAaqAPGAT+UN1HkWbkIuBjyTwNrJNcG/MRYNLp87x0LMTL6mBm9GCq0yrgaGQSWWR+Bq5xdYuAh6ST1b9YJOxeNTQ/uC1VV0SiF9gAbAZ2AfuAk5J1Vu/fqs7aDKtPWTKG2+U/Vn8XOTBn+kmNHg0gMQRsA06VsPP0Y322AusDyDymuh+BxVlERp1TlTEn85XdKcW+BMY0s2bnKzTYYr2vU9048JXrdw74UPVlzCwJQhZRZ2GnKh8vIGFPE/hH5dPAFrUNxSoFlmnJaolkX4rM0RSZTSq30DwLh1V5cwcSVwN7nR+N6Ut3i0vkwC3Jttm6qgOZW1T2XZawv1V5aQ6JG4DfVGaOPEB8DAL7NcavwPU5ZC7T7zOdiGzMIXFaZRZ1LqY+LAMmnNlmkdmo9z87mdaZDHNKZuI1OVvd6AG2u5m5MkUm0fH7rM47XBTxjr3XzcRckPBk3nXRMB0Acp19NCPENp1P1GlOnczsgHSwwEKKjOk8C9bgrdQ60dLTrWOHLpQe650ea1W2VMlqqRRpd+pLzBcRbxnvE4ghdfw90jpRBMtyj2jMqZx1ZloZgFlKaWyTUFt168ZNwAmN90mHDzemNq+UFdzrEsAqaUcI7tRakETFvoJZa4t0qd3iBhfy6sQDLl97tWRo/0btLUUpxOaITp6Hp5xj23tZNEP6JOmBpduxsUhfv63ZsFkJwYj6vlOm8T41TmJ2LPTJD5IcyfwjFAMdItssHFdjC3mxsEIRKXFWi1RVsFIyLPcrRLLBr3yOlIEpyTyi6FMVvZJjmfq8EOl2Za9EJDGtfhYekZUhplWXs8fAQIiz76ox/HaLEelmR6yFeDpgQaxiHt2gKdlPlmk87E4yFhqRydRJT0f0umw0JGm8wyWbpWw4EGuco2eeMGZha0Aab9cCTwD/Ovu1LWpsjIem8Ul0OKfrAwt5eVimLWdb7Z8re+QfiH63sQqOph+UOMJPVuxTMq268JLGsVOVSjY5o03/4Dw6+5B0MF2urSpki5Tan2P3dRNZrrvLtsy2MiyCfSFBEzo0myv0AO9p7D0xcr8rgGMSuH2OyPQAr2vMX4DLYwlODo0Th6sjvCZY7mairbGjoJG6VW3rGNNfl8V07IOpsSalQzQSFmpvdD7TUu4TI93vV4htSfbnusqYikEmTaLh9t7PukGnlWCurhjix93dSwt4xt32Nrol40nkCbguZcttnTs1lW4Pat+/RE+/ykbUJm2uFhXXVNQlF3sCOq5VbpbsLEOe4+prH6UTPJnPQoh8KjttBIbMYe0VJmQSyR8GZvQ+qY2btbk1MJQ3pJPpdh4sdPwHzhQd7V020iEAAAAASUVORK5CYII="></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][10]}}</div>
				  				<div class="px-0 row mx-0 align-self-center" style="width:180px">
				  					<select style="font-size:1.2rem; font-weight: bold" v-model=sleep_start name="Sleep_start_value" class="col form-control">
				  						<option value="0" selected="selected">0{{msglist[$route.params.language][14]}}</option>
				  						<option value="1">1</option>
				  						<option value="2">2</option>
				  						<option value="3">3</option>
				  						<option value="4">4</option>
				  						<option value="5">5</option>
				  						<option value="6">6</option>
				  						<option value="7">7</option>
				  						<option value="8">8</option>
				  						<option value="9">9</option>
				  						<option value="10">10</option>
				  						<option value="11">11</option>
				  						<option value="12">12</option>
				  						<option value="13">13</option>
				  						<option value="14">14</option>
				  						<option value="15">15</option>
				  						<option value="16">16</option>
				  						<option value="17">17</option>
				  						<option value="18">18</option>
				  						<option value="19">19</option>
				  						<option value="20">20</option>
				  						<option value="21">21</option>
				  						<option value="22">22</option>
				  						<option value="23">23</option>
				  					</select>
				  					<span class="col-auto px-2 align-self-center"> - </span>
				  					<select style="font-size:1.2rem; font-weight: bold" v-model=sleep_end name="Sleep_end_value" class="col form-control">
				  						<option value="0" selected="selected">0{{msglist[$route.params.language][14]}}</option>
				  						<option value="1">1</option>
				  						<option value="2">2</option>
				  						<option value="3">3</option>
				  						<option value="4">4</option>
				  						<option value="5">5</option>
				  						<option value="6">6</option>
				  						<option value="7">7</option>
				  						<option value="8">8</option>
				  						<option value="9">9</option>
				  						<option value="10">10</option>
				  						<option value="11">11</option>
				  						<option value="12">12</option>
				  						<option value="13">13</option>
				  						<option value="14">14</option>
				  						<option value="15">15</option>
				  						<option value="16">16</option>
				  						<option value="17">17</option>
				  						<option value="18">18</option>
				  						<option value="19">19</option>
				  						<option value="20">20</option>
				  						<option value="21">21</option>
				  						<option value="22">22</option>
				  						<option value="23">23</option>
				  					</select>
				  				</div>
		  				</div>
		  		</div>
		  </div>
      
      <div class="col-12 row mx-0 px-0 py-3 mb-1 justify-content-center" style="background: rgb(242, 242, 242);">
		  			<button v-if="name!=='khacra'" @click=apply name="KH_settings_button" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][11]}}</button> <!--套用-->
		        <!--<div class="col-auto"><span v-bind:class="alertObject"> {{message}} </span></div>-->
          </div>

      <div class="col-12 row mx-0 px-0 py-2 mb-1 justify-content-center">
          <div class="col-12 px-0">{{msglist[$route.params.language][12]}}</div>  <!--按 [套用] 鍵, 設定值會在下次量測時生效-->
          <div class="col-12 px-0 mt-3">{{msglist[$route.params.language][13]}}</div> <!--如果想要立即生效，請在控制器上選[Sync]同步 -->
      </div>
        
	</div>
</div>
    
</template>
<script>


import {
	mapLang
} from "../routes.js";

const mlist = {
	'en': [
        'My KH',
        'KHA Settings',
        'Target Tank KH :',
        'If lower, then dose KH',
        'Notify if Out of Spec',
        ' dKH , notify me',
        'through E-mail',
        'Measurement Every',
        'hour',
        'Set 1 hour for accuracy',
        'KHA Sleep Time',
        'Apply',
        'Press [Apply], new settings will take effect in the next measurement.',
        'To update KHA immediately, please select [SYNC] in KHA LCD menu.',
        '', 
        'Applied',
        'Error'],
  'vi': [
        'KH Của Tôi',
        'Cài Đặt KHA',
        'Mục Tiêu KH :',
        'Nếu thấp hơn KH trong bể thì đặt mục tiêu mong muốn',
        'Thông báo thông số kỹ thuật ',
        ' dKH , Vui Lòng Thông Báo',
        'qua E-mail',
        'Đo Lường Mỗi Giờ',
        'Giờ',
        'Đặt 1 giờ cho chính xác',
        'KHA Trong Trạng Thái Nghỉ',
        'Áp Dụng',
        'Nhấn [Áp dụng], cài đặt mới sẽ có hiệu lực trong lần đo tiếp theo.',
        'Để cập nhật KHA ngay lập tức, vui lòng chọn [SYNC] trong menu KHA LCD.',
        '', 
        'Đã Áp Dụng',
        'Lỗi'],
  'ms': [
        'My KH',
        'KHA Settings',
        'Target Tank KH :',
        'If lower, then dose KH',
        'Notify if Out of Spec',
        ' dKH , notify me',
        'through E-mail',
        'Measurement Every',
        'hour',
        'Set 1 hour for accuracy',
        'KHA Sleep Time',
        'Apply',
        'Press [Apply], new settings will take effect in the next measurement.',
        'To update KHA immediately, please select [SYNC] in KHA LCD menu.',
        '', 
        'Applied',
        'Error'],
	'tw': [
        '我的KH',
        'KHA 設定',
        'KH目標值',
        '小於目標，開啟滴定',
        '超出範圍，',
        ' dKH 時通知',
        'E-mail通知',
        '幾小時測一次',
        '小時',
        '每小時測一次，控制更精確',
        'KHA休眠時間 ',
        '套用',
        '按 [套用]， 設定值會在下次量測時生效 ',
        '如要立即生效，請在KHA LCD選單上選[Sync]同步',
        '', //(預設)',
        '已套用',
        '錯誤'],
	'cn': [
        '我的KH',
        'KHA 设定',
        'KH目标值:',
        '小于目标，开启滴定',
        '超出范围，',
        ' dKH 时通知',
        'E-mail通知',
        '几小时测一次',
        '小时',
        '每小时测一次，控制更精确',
        'KHA休眠时间',
        '套用',
        '按 [套用] 键，设定值会在下次量测时生效。',
        '如要立即生效，请在KHA LCD选單选 [Sync]',
        '', //(预设)',
        '已套用',
        '错误'],
}

//import Log from 'loglevel';
import has from 'lodash/has';

let PURL = process.env.SERVER;

function startCfg(Vue) {
    let url = PURL + '/api/v1/KH/start-config';
    let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};  
    let body = {
		"user": user.name,
        "serial": ''
    };

    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload or change language
    has(user, 'data.devices') ? body.serial = user.data.devices[sidx] : '';
    if (Vue.targetKH <1) {Vue.targetKH=1;} // limit target KH >1.0
    if (Vue.timeHr <1) {Vue.timeHr =1;} // limit timer hr >=1 hour 
    if (Vue.KHspec <0.1) {Vue.KHspec =0.1;} // limit KHspec >0.1
    /////// update parameter in database ////////
    body['field8'] = ""+ (Number(Vue.targetKH) * 1000).toFixed(0);
    body['field13'] = ""+ (Number(Vue.timeHr) * 10000 + Number(Vue.sleep_start)*100 + Number(Vue.sleep_end));
    body['field15'] = ""+ (Number(Vue.KHspec) * 1000).toFixed(0);
    /////// update parameters in localstorage ////////
    if (user.sleep) {
      Vue.$set(user.targetKH, sidx, Vue.targetKH);
      //Vue.$set(user.timeHr, sidx, body['field9']);
      Vue.$set(user.sleep, sidx, body['field13']);
      Vue.$set(user.KHspec, sidx, Number(Vue.KHspec));
      localStorage.setItem('user', JSON.stringify(user));
    }
    // asynch call
    let p1 = Vue.$http.post(url, body);
    //let p2 = Vue.$http.get(PURL + '/api/v1/KH/' + body.serial + '/pending-config/field3'); // 查詢 pending config 狀態
    //Promise.all([p1, p2]).then(([r1, r2]) => {
    Promise.all([p1]).then(([r1]) => {
    console.log("KH-settings -- new parameters applied");
        Vue.setMsg(mlist[Vue.getLang()][15], 5);
    }, reason => {
        console.log('server error: ', reason);
        Vue.setMsg_logout(mlist[Vue.getLang()][16], 2);
    });
}

function fetch89(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   

  let body = {
    "user": user.name,
    "password": ''
  };
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
      let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
    
  if (user && user.sleep) { // if localstorage user && user.sleep exist, then restore Vue.u parameters from localstorage
      //////// get parameters from localstorage /////
      Vue.name=user.name;
      Vue.targetKH = user.targetKH[sidx];
      Vue.KHspec = user.KHspec[sidx]; 
      Vue.timeHr = user.timeHr[sidx];
      Vue.sleep_start = Math.floor((user.sleep[sidx] % 10000) / 100);
      Vue.sleep_end = (user.sleep[sidx] % 10000) % 100;  
      console.log("KH-settings -- get parameters from localstorage");
  } else {  
      //////// get parameters from server /////
      let urls = PURL + '/api/v1/KH/' + user.data.devices[sidx] + '/' + 'all_field';
			let ps = Vue.$http.post(urls, body);
			Promise.all([ps]).then(([rs]) => {
				if ((rs.status === 200 || rs.status === 204)) {
          Vue.targetKH = rs.data['field8']/1000;
          Vue.KHspec = rs.data['field15']/1000; 
          Vue.timeHr = Math.round(rs.data['field13']/10000); if (Vue.timeHr > 6) {Vue.timeHr =1;}
          Vue.sleep_start = Math.floor((rs.data['field13'] % 10000) / 100);
          Vue.sleep_end = (rs.data['field13'] % 10000) % 100;
					console.log("KH-settings -- get parameters from server");
	      }
      }, reason => {
        console.log('server error: ', reason);
				Vue.setMsg_logout(mlist[Vue.getLang()][16], 2);
      });
      
  }  // if user && user.sleep
}

export default {
  data: () => {
    return {
      disabled: false,
      title: "KH Setting",
      targetKH: "7.5",
      KHspec: "0.5",
      timeHr: "1",
      sleep_start: "0",
      sleep_end: "0",
      message: "",
      msglist: mlist,
      name:"",
      time_out:"",
      //userS: localStorage.getItem('user')
    }  // return
  },  // data:
  created: function () {
    // `this` points to the vm instance
	fetch89(this);
    //console.log('current targetKH= ' + this.targetKH , 'KH spec= ' + this.KHspec + 'timeHr=' + this.timeHr + ', sleep_start=' + this.sleep_start + ', sleep_end=' + this.sleep_end );
    window.scrollTo( 0, 1); // to remove address bar
  },
  destroyed: function () {
    //console.log('KH-setting destroy step');
    //clearInterval(this.time_out);
    clearTimeout(this.time_out);
  },
  computed: {
	alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },

  },
  methods: {
    getLang: function () {
		  //console.log("lang: ", mapLang(), this.$route.params);
		  if (has(this.$route, "params.language")) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
	},
    setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
    },
    setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
    },    
    apply: function () {
      //console.log("this: ", this.$http, startCfg, this.$store.user);
      this.disable();
      startCfg(this);
    },
    disable: function() { this.disabled = true; },
    enable: function() { this.disabled = false; },
	},
  mounted() {
		
		if (this.$auth.loggedIn()) {
			this.time_out=setTimeout( () => {     // return to my-kh after 5 min
        this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, 600*1000);
        //return this.fillData(1);
		} else {
      this.$auth.destroyToken();
			this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
		}
  }

} // export
</script>

<style type="text/css">#form{margin:3em auto}</style><style type="text/css"></style><style type="text/css">/* Chart.js */
/*
 * DOM element rendering detection
 * https://davidwalsh.name/detect-node-insertion
 */
@keyframes chartjs-render-animation {
	from { opacity: 0.99; }
	to { opacity: 1; }
}

.chartjs-render-monitor {
	animation: chartjs-render-animation 0.001s;
}

/*
 * DOM element resizing detection
 * https://github.com/marcj/css-element-queries
 */
.chartjs-size-monitor,
.chartjs-size-monitor-expand,
.chartjs-size-monitor-shrink {
	position: absolute;
	direction: ltr;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	pointer-events: none;
	visibility: hidden;
	z-index: -1;
}

.chartjs-size-monitor-expand > div {
	position: absolute;
	width: 1000000px;
	height: 1000000px;
	left: 0;
	top: 0;
}

.chartjs-size-monitor-shrink > div {
	position: absolute;
	width: 200%;
	height: 200%;
	left: 0;
	top: 0;
}
</style>



// WEBPACK FOOTER //
// KH_settings.vue?b77c8de4